import { IconProps } from "./interfaces/IconProps.interface"
import { memo } from "react"

const TimerFill = memo((props: IconProps) => {
    const { color = "#fff" } = props
    return (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M17.618 5.968L19.071 4.515L20.485 5.929L19.032 7.382C20.4678 9.17917 21.1609 11.4579 20.9691 13.7501C20.7772 16.0424 19.715 18.1742 18.0005 19.7077C16.286 21.2412 14.0494 22.0601 11.75 21.9961C9.45061 21.9321 7.26301 20.9901 5.63647 19.3635C4.00993 17.737 3.06793 15.5494 3.00392 13.25C2.93991 10.9506 3.75875 8.71402 5.29228 6.99951C6.82581 5.285 8.95761 4.22275 11.2499 4.03092C13.5421 3.83909 15.8208 4.53223 17.618 5.968V5.968ZM11 8V14H13V8H11ZM8 1H16V3H8V1Z"
                fill={color}
            />
        </svg>
    )
})

export default TimerFill
